import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["PreTripStatus", { 'PreTripStatus--red': _ctx.status.id === 5 }])
  }, _toDisplayString(_ctx.status.name), 3))
}